import {
  SETTING_ACCOUNT_PAGE_REQUEST,
  SETTING_ACCOUNT_REQUEST
} from './constants'

export function accountPageRequest () {
  return {type: SETTING_ACCOUNT_PAGE_REQUEST, payload: {}}
}

export function settingAccountRequest (data) {
  return {type: SETTING_ACCOUNT_REQUEST, payload: {data}}
}



// WEBPACK FOOTER //
// ./app/actions/setting/account/index.js